
<div
  class="tab-pane fade show"
  [ngClass]="page == 'profilePage' ? 'show active' : ''"
  id="pills-profile"
  role="tabpanel"
  aria-labelledby="pills-profile-tab"
>
  <form [formGroup]="profileFormGroup">
    <h1 class="page-sub-title cv-text-dark mb-4 mt-4 d-flex align-items-center">
      <a (click)="mobileBack()" class=""
        ><img
          [src]="environment1 + 'assets/images/c-arrow-left.svg'"
          class="img-fluid me-2"
          loading="lazy" /></a
      >Profile
      <div class="ms-auto action-edit">
        <span
          (click)="clickToEdit()"
          class="view-more"
          *ngIf="!isAllowToEdit"
          data-toggle="tooltip"
          data-placement="top"
          title="Click here for Edit Profile"
          >Edit</span
        >
        <span
          (click)="clickToEdit('Cancel')"
          class="view-more"
          *ngIf="isAllowToEdit"
          data-toggle="tooltip"
          data-placement="top"
          title="Click here for Cancel"
          >Cancel</span
        >
      </div>
    </h1>
    <div class="row p-3">
      <div class="col-12 col-sm-12 col-md-6 col-lg-12 col-xl-12 mb-4">
        <label class="form-label mend">Account Type</label>
        <div class="d-flex gap-5">
          <div *ngFor="let pan of panTypeOptions let i = index"  class="accountType"  [attr.disabled]="((isIdKYCDone && isAddKYCDone) || isIdKYCDone) ? true : null">
            <input
              type="radio"
              class="accountTypeInput"
              name="pan_type"
              [value]="pan.value"
              (change)="updateFirstNameValidation($event.target.value)"
              [attr.disabled]="((isIdKYCDone && isAddKYCDone) || isIdKYCDone || !isAllowToEdit ) ? true : null"

              formControlName="pan_type"
              [id]="'panType' + i"
            />
            <!-- [attr.disabled]="!isAllowToEdit || isIdKYCDone && isAddKYCDone ? '' : null" -->

            <label class="ms-2" [for]="'panType' + i">{{ pan.label }}</label>
          </div>
        </div>

        <div class="error-message" *ngIf="hasRequiredError('pan_type')">
          <b> &nbsp; Pan Type is Required</b>
        </div>
      </div>
      <div
        class="col-12 col-sm-12 col-md-6 col-lg-12 col-xl-12 mb-4"
        *ngIf="profileFormGroup.get('pan_type')?.value === 'Company'"
      >
        <label class="form-label mend">Company Name</label>
        <input
          formControlName="full_name"
          type="text"
          class="form-control h-48"
          placeholder="Ex. Pratik Pvt Ltd"
          [attr.disabled]="isIdKYCDone || !isAllowToEdit ? true : null"
   
          (input)="validateCompanyName($event)"
          (blur)="checkCompanyNameError()"
          maxlength="50"
         
        />
        <div *ngIf="companyNameError" class="error-message alert-danger">
          <b>Company Name cannot contain &lt;, &gt;, &#123;, &#125;, &#124;, &#126;, &#94;, &#42;</b> Please input correct details.
        </div>
        <div class="error-message" *ngIf="hasRequiredError('full_name')">
          <b> &nbsp; Company Name is Required</b>
        </div>
        <div
          class="error-message"
          *ngIf="hasError('full_name', 'invalidCompanyName')"
        >
          <b
            >Company Name cannot contain &lt; &gt; &#123; &#125; &#124; &#126;
            &#94; &#42;</b
          >
        </div>
      </div>
      <div
        class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-4"
        *ngIf="profileFormGroup.get('pan_type')?.value === 'Individual'"
      >
        <label class="form-label mend">First Name</label>
        <input
          formControlName="first_name"
          [readonly]="!isAllowToEdit"
          type="text"
          class="form-control h-48"
          placeholder="Ex. Pratik"
          maxlength="50"
          [attr.disabled]="(isIdKYCDone && isAddKYCDone) || !isAllowToEdit ? true : null"
          name="first_name"
          (keydown)="notAllowSpace($event)"
          (input)="onInput($event)"
          (input)="validateName($event, 'firstName')"
          (blur)="checkNameError('firstName')"
        />
        <div *ngIf="nameErrors.firstName" class="error-message alert-danger">
          <b>First Name cannot contain special characters (&period; &quot; &commat; &num; &dollar; and others)</b>

        </div>
        <div class="error-message" *ngIf="hasRequiredError('first_name')">
          <b> &nbsp; First Name is Required</b>
        </div>
        <!-- <div
          class="error-message"
          *ngIf="hasError('first_name', 'invalidIndividualName')"
        >
          <b>First Name cannot contain special characters </b>
        </div> -->
      </div>
      <div
        class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-4"
        *ngIf="profileFormGroup.get('pan_type')?.value === 'Individual'"
      >
        <label class="form-label mend">Last Name</label>
        <input
          formControlName="last_name"
          name="last_name"
          [readonly]="!isAllowToEdit"
          type="text"
          class="form-control h-48"
          placeholder="Ex. Maurya"
          maxlength="50"
          [attr.disabled]="(isIdKYCDone && isAddKYCDone) || !isAllowToEdit ? true : null"
          (keydown)="notAllowSpace($event)"
          (input)="onInput($event)"
          (input)="validateName($event, 'lastName')"
          (blur)="checkNameError('lastName')"
        />
        <div *ngIf="nameErrors.lastName" class="error-message alert-danger">
          <b>Last Name cannot contain special characters (&period; &quot; &commat; &num; &dollar; and others)</b>

        </div>
        <div class="error-message" *ngIf="hasRequiredError('last_name')">
          <b> &nbsp; Last Name is Required</b>
        </div>
        <!-- <div
          class="error-message"
          *ngIf="hasError('last_name', 'invalidIndividualName')"
        >
          <b>Last Name cannot contain special characters </b>
        </div> -->
      </div>
      <div class="col-12 col-sm-12 col-md-6 col-lg-12 col-xl-12 mb-4">
        <label class="form-label mend">Email</label>
        <input
          formControlName="email_id"
          [readonly]="!isAllowToEdit"
          type="text"
          name="email_id"
          class="form-control h-48"
          placeholder="Ex. xyz@gmail.com"
          maxlength="60"
          [attr.disabled]="!isAllowToEdit ? '' : null"
          (keydown)="nAllowSpace($event)"
          (keyup)="emailValidator($event)"
          (input)="onInput($event)"
        />
        <div class="error-message" *ngIf="hasRequiredError('email_id')">
          <b> &nbsp; Email is Required</b>
        </div>
        <div class="error-message" *ngIf="showEmailError">
          <b> &nbsp; Please enter valid email id</b>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-6 col-lg-12 col-xl-12 mb-4">
        <label class="form-label">Enter your mobile number</label>
        <div class="form-input" style="background-color: #e9ecef">
          <div class="country-code">+91</div>
          <input
            formControlName="mobile_number"
            name="mobile_number"
            readonly
            type="text"
            class="mobileno"
            placeholder="Mobile Number"
            style="background-color: #e9ecef"
          />
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-4">
        <label class="form-label mend">Address</label>
        <textarea
          formControlName="address"
          name="address"
          [readonly]="!isAllowToEdit"
          class="form-control"
          cols="30"
          maxlength="200"
          rows="5"
          [attr.disabled]="!isAllowToEdit ? '' : null"
          (keydown)="notAllowSpace($event)"
          (input)="onInput($event)"
        >
Address</textarea
        >
        <div class="error-message" *ngIf="hasRequiredError('address')">
          <b> &nbsp; Address is Required</b>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-4">
        <label class="form-label mend">State</label>
        <select
          formControlName="state"
          name="state"
          class="form-select h-48"
          (change)="getDistrictList('true')"
          [attr.disabled]="!isAllowToEdit ? '' : null"
        >
          <option value="" [disabled]="!isAllowToEdit">Select State...</option>
          <option
            *ngFor="let state of stateList"
            value="{{ state.name }}"
            [disabled]="!isAllowToEdit"
          >
            {{ state.name | titlecase }}
          </option>
        </select>
        <div class="error-message" *ngIf="hasRequiredError('state')">
          <b> &nbsp; State is Required</b>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-4">
        <label class="form-label mend">District</label>
        <select
          formControlName="district"
          name="district"
          class="form-select h-48"
          [attr.disabled]="!isAllowToEdit ? '' : null"
        >
          <option value="" [disabled]="!isAllowToEdit">
            Select District...
          </option>
          <option
            *ngFor="let district of districtList"
            value="{{ district }}"
            [disabled]="!isAllowToEdit"
          >
            {{ district | titlecase }}
          </option>
        </select>
        <div class="error-message" *ngIf="hasRequiredError('district')">
          <b> &nbsp; District is Required</b>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-4 text-end mt-3 d-grid d-sm-block">
        <button type="button" class="btn btn-danger btn-lg ps-5 pe-5 pt-md-3 pb-md-3"
          data-bs-toggle="modal" data-bs-target="#logout-modal" *ngIf="!isAllowToEdit"
          data-toggle="tooltip" data-placement="top" title="Click here for Logout">Logout</button>
        <button type="button"
          class="btn btn-primary btn-md btn-grad-primary btn-brand ps-5 pe-5 pt-md-3 pb-md-3"
          data-toggle="tooltip" data-placement="top" title="Click here for Save Profile"
          *ngIf="isAllowToEdit" (click)="save()">Save</button>
      </div>
    </div>
  </form>
</div>
